
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import path$1 from './path.js';
import hasOwnProperty_1 from './has-own-property.js';
import './well-known-symbol-wrapped.js';
import './object-define-property.js';
import { __exports as objectDefineProperty } from '../../../_virtual/object-define-property.js';
import { __exports as wellKnownSymbolWrapped } from '../../../_virtual/well-known-symbol-wrapped.js';

var path = path$1;
var hasOwn = hasOwnProperty_1;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineProperty = objectDefineProperty.f;

var wellKnownSymbolDefine = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};

export { wellKnownSymbolDefine as default };
//# sourceMappingURL=well-known-symbol-define.js.map
